import {
  QueryClient,
  defaultShouldDehydrateQuery,
} from "@tanstack/react-query";
import { persistQueryClient } from "@tanstack/react-query-persist-client";
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";

export const queryClient = new QueryClient();

const localStoragePersister = createSyncStoragePersister({
  storage: window.localStorage,
});

persistQueryClient({
  queryClient,
  persister: localStoragePersister,
  maxAge: 1000 * 60 * 60 * 24, // 24 hours
  dehydrateOptions: {
    // Opt-out for queries that must not be written to localStorage — set
    // `meta: { persist: false }` on the query. Used by anything holding
    // credentials or other data that shouldn't outlive the page.
    shouldDehydrateQuery: (query) =>
      query.meta?.persist !== false && defaultShouldDehydrateQuery(query),
  },
});

/** The key `createSyncStoragePersister` writes the dehydrated cache under. */
export const PERSISTED_QUERY_CACHE_KEY = "REACT_QUERY_OFFLINE_CACHE";

/**
 * Drop every cached query, the persisted snapshot included.
 *
 * `queryClient.clear()` on its own only empties the in-memory cache — the
 * localStorage copy survives, and the next load rehydrates exactly what was
 * just cleared. Both have to go, in that order, so the persister's own write
 * after the clear can't resurrect anything.
 */
export const clearQueryCache = () => {
  queryClient.clear();
  try {
    localStorage.removeItem(PERSISTED_QUERY_CACHE_KEY);
  } catch (error) {
    console.warn("Could not clear the persisted query cache", error);
  }
};
